(function(window, rum) {
    var PATH_CLIENT_ERROR = '690.2354'; // tech.client_error
    var PATH_UNCAUGHT_ERROR = '690.2361'; // tech.uncaught_error
    var PATH_EXTERNAL_ERROR = '690.2854'; // tech.external_error
    var PATH_SCRIPT_ERROR = '690.2609'; // tech.script_error

    var LIMIT_CLIENT_ERROR = 1000;
    var LIMIT_UNCAUGHT_ERROR = 100;
    var LIMIT_EXTERNAL_ERROR = 100;
    var LIMIT_SCRIPT_ERROR = 100;

    var SILENT_LIMIT_CLIENT_ERROR = 100;
    var SILENT_LIMIT_UNCAUGHT_ERROR = 10;
    var SILENT_LIMIT_EXTERNAL_ERROR = 10;
    var SILENT_LIMIT_SCRIPT_ERROR = 10;

    var types = {
        // type: [path, limit, silentLimit, sent]
        client: [PATH_CLIENT_ERROR, LIMIT_CLIENT_ERROR, SILENT_LIMIT_CLIENT_ERROR, 0],
        uncaught: [PATH_UNCAUGHT_ERROR, LIMIT_UNCAUGHT_ERROR, SILENT_LIMIT_UNCAUGHT_ERROR, 0],
        external: [PATH_EXTERNAL_ERROR, LIMIT_EXTERNAL_ERROR, SILENT_LIMIT_EXTERNAL_ERROR, 0],
        script: [PATH_SCRIPT_ERROR, LIMIT_SCRIPT_ERROR, SILENT_LIMIT_SCRIPT_ERROR, 0]
    };

    var pending = {};

    rum.ERROR_LEVEL = {
        INFO: 'info',
        DEBUG: 'debug',
        WARN: 'warn',
        ERROR: 'error',
        FATAL: 'fatal'
    };

    // можно переопределить при инициализации
    rum._errorSettings = {
        clck: 'https://yandex.ru/clck/click',
        beacon: true,
        project: 'unknown',
        page: '',
        env: '',
        experiments: [],
        additional: {},
        platform: '',
        // регион из геобазы
        region: '',
        dc: '',
        host: '',
        service: '',
        level: '',
        version: '',
        yandexuid: '',
        loggedin: false,
        coordinates_gp: '',
        referrer: true,
        preventError: false,
        unhandledRejection: false,
        traceUnhandledRejection: false,
        uncaughtException: true,
        debug: false,
        limits: {},
        silent: {},
        filters: {},
        pageMaxAge: 10/*day*/ * 24/*hours*/ * 60/*minutes*/ * 60/*seconds*/ * 1000 /*ms*/,
        initTimestamp: +new Date()
    };

    var inited = false;

    /**
     * Инициализация параметров для отправки ошибок
     *
     * @param {Object} settings
     */
    rum.initErrors = function(settings) {
        var errorSettings = objectExtend(rum._errorSettings, settings);
        if (inited) {
            return;
        }

        if (errorSettings.uncaughtException) {
            subscribe();
        }
        if (errorSettings.unhandledRejection && errorSettings.traceUnhandledRejection && rum._traceUnhandledRejection) {
            rum._traceUnhandledRejection();
        }

        inited = true;
    };

    /**
     * Изменение параметров для отправки ошибок
     *
     * @param {Object} settings
     */
    rum.updateErrors = function(settings) {
        objectExtend(rum._errorSettings, settings);
    };

    /**
     * Shallow merge additional
     *
     * @param {Object} additional
     */
    rum.updateAdditional = function(additional) {
        rum._errorSettings.additional = objectExtend(rum._errorSettings.additional || {}, additional);
    };

    /**
     * Обрабатывает ошибку и отправляет счётчик.
     * В случае режима отладки, выводит отладочную информацию в консоль браузера.
     *
     * @param {Error} event
     * @param {Boolean} isCustom
     * @param {Object} settingsFromError
     */
    rum._handleError = function(event, isCustom, settingsFromError) {
        var settings = rum._errorSettings;
        var transform = settings.transform;

        if (settings.preventError && event.preventDefault) {
            event.preventDefault();
        }

        var error, errorType;

        if (!isCustom) {
            error = rum._normalizeError(event);
            errorType = error.type;

            var onError = settings.onError;
            if (typeof onError === 'function') {
                onError(error);
            }
            if (typeof transform === 'function') {
                error = transform(error);
            }
            if (!error) {
                return;
            }
            if (error.settings) {
                settingsFromError = error.settings;
            }
        } else {
            error = typeof transform === 'function' ? transform(event) : event;
            errorType = 'client';
            if (!error) {
                return;
            }
        }
        var currentTimestamp = +new Date();
        var initTimestamp = settings.initTimestamp;
        var pageMaxAge = settings.pageMaxAge;
        if (pageMaxAge !== -1 && initTimestamp && initTimestamp + pageMaxAge < currentTimestamp) {
            return;
        }

        var limit = types[errorType][1];
        if (typeof settings.limits[errorType] === 'number') {
            limit = settings.limits[errorType];
        }
        var silentLimit = types[errorType][2];
        if (typeof settings.silent[errorType] === 'number') {
            silentLimit = settings.silent[errorType];
        }

        var sent = types[errorType][3];
        if (sent < limit || limit === -1) {
            error.path = types[errorType][0];

            /* В первой итерации решили писать как есть
            if (error.stack) {
                // Убираем первую строку - обычно она равна msg.
                // Вырезаем yastatic.net чтобы сэкономить место в логах
                error.stack = error.stack
                    .split('\n').slice(1, 7).join('; ')
                    .replace(/\s+/g, ' ')
                    .replace(/https:\/\/([^.]+\.)?yastatic.net/, '$1');
            }
            */

            var sendData = rum._getErrorData(error, {
                silent: sent < silentLimit || silentLimit === -1 ? 'no' : 'yes',
                isCustom: Boolean(isCustom)
            }, objectExtend(objectExtend({}, settings), settingsFromError));

            var send = function(sendData) {
                pending[error.message] = false;

                rum._sendError(sendData.path, sendData.vars);

                types[errorType][3]++;
            }.bind(this, sendData);

            if (typeof settings.throttleSend === 'undefined') {
                send();
            } else {
                if (pending[error.message]) {
                    return;
                }

                pending[error.message] = true;

                setTimeout(send, settings.throttleSend);
            }
        }
    };


    /**
     *
     * @param {Object} settings
     *
     * return {String}
     */
    rum._getReferrer = function(settings) {
        var settingsReferrer = settings.referrer;
        var typeOfSettingsReferrer = typeof settingsReferrer;

        if (typeOfSettingsReferrer === 'function') {
            return settingsReferrer();
        }

        if (typeOfSettingsReferrer === 'string' && settingsReferrer) {
            return settingsReferrer;
        }

        if (settingsReferrer === false) {
            return undefined;
        }

        return window.location ? window.location.href : undefined;
    };

    /**
     *
     * @param {String} settings
     *
     * return {String|Number|Function}
     */
    rum.getErrorSetting = function(key) {
        return rum._errorSettings[key];
    };

    /**
     * Преобразует масссив экспериментов в строку
     *
     * @param {Array} settingsExperiments
     * @returns {String}
     */
    rum._buildExperiments = function(settingsExperiments) {
        return settingsExperiments instanceof Array ? settingsExperiments.join(';') : '';
    };

    /**
     * Преобразует два объекта additional в строку
     *
     * @param {Object} settingsAdditional
     * @param {Object} paramsAdditional
     * @returns {String}
     */
    rum._buildAdditional = function(settingsAdditional, paramsAdditional) {
        var additional = '';
        try {
            var additionalObject = objectExtend(objectExtend({}, settingsAdditional), paramsAdditional);
            if (Object.keys(additionalObject).length !== 0) {
                additional = JSON.stringify(additionalObject);
            }
        } catch (e) {/*empty catch*/}

        return additional;
    };

    /**
     * Формирует данные для отправки
     *
     * @param {LogErrors~Error} err
     * @param {Object} params
     * @param {Object} settings
     */
    rum._getErrorData = function (err, params, settings) {
        params = params || {};
        var experiments = rum._buildExperiments(settings.experiments);
        var additional = rum._buildAdditional(settings.additional, err.additional);
        var vars = {
            // генерится браузером
            '-stack': err.stack,
            '-url': err.file,
            '-line': err.line,
            '-col': err.col,

            // блок, в котором произошла ошибка
            '-block': err.block,

            // метод, в котором произошла ошибка
            '-method': err.method,

            // заполняется в событии браузера или передается вручную
            '-msg': err.message,

            // окружение
            '-env': settings.env,

            // вспомогательные поля для понимания типа внешних ошибок
            '-external': err.external,
            '-externalCustom': err.externalCustom,

            // принадлежность к сервису
            '-project': settings.project,
            '-service': err.service || settings.service,
            '-page': err.page || settings.page,

            // платформа
            '-platform': settings.platform,

            // критичность
            '-level': err.level,

            // эксперименты
            '-experiments': experiments,

            // версия статики
            '-version': settings.version,

            // регион
            '-region': settings.region,

            // датацентр
            '-dc': settings.dc,

            // имя хоста
            '-host': settings.host,

            // id пользователя
            '-yandexuid': settings.yandexuid,

            // залогинен ли пользователь
            '-loggedin': settings.loggedin,

            // кука с кооординатами
            '-coordinates_gp': err.coordinates_gp || settings.coordinates_gp,

            '-referrer': rum._getReferrer(settings),

            // источник ошибки
            '-source': err.source,

            // метод/ручка источника ошибки
            '-sourceMethod': err.sourceMethod,

            // тип ошибки
            // logic, render, network, ...
            '-type': params.isCustom ? err.type : '',

            // хэш с дополнительными параметрами
            '-additional': additional,

            // наличие блокировщиков рекламы
            '-adb': castBlocker(Ya.blocker) || castBlocker(settings.blocker),

            // CDN из https://yastatic.net/nearest.js
            '-cdn': window.YaStaticRegion,

            // ua - попробуем брать из кук
            '-ua': navigator.userAgent,

            // если кол-во ошибок от 1 пользователя слишком большое, тогда отсылаем признак,
            // чтобы отфильтровывать эти ошибки в Голован
            '-silent': params.silent,

            // клиентское время ошибки
            '-ts': +new Date(),
            '-init-ts': settings.initTimestamp,
        };

        if (settings.debug && window.console) {
            // eslint-disable-next-line no-console
            console[console[err.level] ? err.level : 'error']('[error-counter] ' + err.message, vars, err.stack);
        }

        return {
            path: err.path,
            vars: vars
        };
    };

    /**
     *
     *
     * @param target {Object}
     * @param object {Object}
     * @return {Object}
     */
    function objectExtend(target, object) {
        for (var name in object) {
            if (object.hasOwnProperty(name)) {
                target[name] = object[name];
            }
        }

        return target;
    }

    /**
     * Приводит ошибки к общему виду.
     *
     * @param {Error} err
     * @returns {Object}
     */
    rum._baseNormalizeError = function (err) {
        err = err || {};
        var error = err.error;
        var file = err.filename || err.fileName || '';
        var stack = (error && error.stack) || err.stack || '';
        var message = err.message || '';
        var additional = (error && error.additional) || err.additional;

        return {
            file: file,
            line: err.lineno || err.lineNumber,
            col: err.colno || err.colNumber,
            stack: stack,
            message: message,
            additional: additional
        };
    };

    /**
     * Приводит ошибки к общему виду c type & external.
     *
     * @param {Error} err
     * @returns {Object}
     */
    rum._normalizeError = function (err) {
        var error = rum._baseNormalizeError(err);
        var type = 'uncaught';
        var externalParams = rum._isExternalError(error.file, error.message, error.stack);
        var externalParamsCommon = '';
        var externalParamsCustom = '';

        if (externalParams.hasExternal) {
            type = 'external';

            externalParamsCommon = externalParams.common;
            externalParamsCustom = externalParams.custom;
        } else if (/^Script error\.?$/.test(error.message)) {
            type = 'script';
        }

        error.external = externalParamsCommon;
        error.externalCustom = externalParamsCustom;
        error.type = type;

        return error;
    };

    /**
     * Преобразует объект c vars в строку.
     *
     * @param {Object} vars
     * @returns {String}
     */
    rum._createVarsString = function(vars) {
        var varsArr = [];

        for (var key in vars) {
            if (vars.hasOwnProperty(key) && (vars[key] || vars[key] === 0)) {
                varsArr.push(key + '=' + encodeURIComponent(vars[key]).replace(/\*/g, '%2A'));
            }
        }

        return varsArr.join(',');
    };

    function castBlocker(value) {
        if (typeof(value) === 'boolean') {
            value = +value;
        }
        if (typeof (value) === 'number') {
            return value + '';
        }

        return null;
    }

    /**
     * Отправляет счётчик об ошибке
     *
     * @param {string} path
     * @param {Object} vars
     */
    rum._sendError = function(path, vars) {
        rum.send(null, path, rum._createVarsString(vars), null, null, null, null);
    };

    /**
     * Отправляет неотловленную ошибку
     *
     * @param {ErrorEvent} event
     */
    var handleError = function(event) {
        rum._handleError(event, false);
    };

    /**
     * Отправляет ошибку загрузки ресурса
     * @param {ErrorEvent} event
     */
    var handleResourceLoadFailure = function(event) {
        var target = event.target;
        if (!target) {
            return;
        }

        var url = target.srcset || target.src;
        if (!url) {
            url = target.href;
        }

        if (!url) {
            return;
        }

        var tag = target.tagName || 'UNKNOWN';

        rum.logError({
            message: tag + ' load error',
            additional: {src: url}
        });
    };

    /**
     * Получает stacktrace для unhandledrejection, если включена опция traceUnhandledRejection
     *
     * @param {Promise} promise
     * @returns {String|undefined}
     */
    rum._parseTraceablePromiseStack = function() {
        // имплементация в ./traceUnhandledRejection.js
    };

    function subscribe() {
        var errorSettings = rum._errorSettings;

        if (window.addEventListener) {
            // обработчик ошибок, которые не были перехвачены через try..catch
            window.addEventListener('error', handleError);

            // обработка ошибок загрузки ресурсов
            if (errorSettings.resourceFails) {
                window.addEventListener('error', handleResourceLoadFailure, true);
            }

            if ('Promise' in window && errorSettings.unhandledRejection) {
                window.addEventListener('unhandledrejection', function (event) {
                    var reason = event.reason;
                    var message, stack, additional = {};

                    if (reason) {
                        if (reason.stack && reason.message) {
                            message = reason.message;
                            stack = reason.stack;
                        } else {
                            message = String(reason);
                            stack = rum._parseTraceablePromiseStack(event.promise);

                            if (message === '[object Event]') {
                                message = 'event.type: ' + reason.type;
                            } else if (message === '[object Object]') {
                                additional.unhandledObject = reason;
                            }
                        }

                        if (reason.target && reason.target.src) {
                            additional.src = reason.target.src;
                        }

                        handleError({
                            message: 'Unhandled rejection: ' + message,
                            stack: stack,
                            additional: additional
                        });
                    }
                });
            }
        } else {
            // фоллбек для старых браузеров
            var oldOnError = window.onerror;
            window.onerror = function (message, file, lineNumber, columnNumber, error) {
                handleError({
                    error : error || new Error(message || 'Empty error'),
                    message : message,
                    lineno : lineNumber,
                    colno: columnNumber,
                    filename : file
                });

                if (oldOnError) {
                    oldOnError.apply(this, arguments);
                }
            };
        }
    }
})(typeof self !== 'undefined' ? self : window, Ya.Rum);
